





































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GetPhoneCode, PwdLogin, Register } from '../api/login/index';
import { checkBpCaptcha } from '../api/enterprise/index';
import { GetProvinces, GetCity } from '../api/common/index';

import request from '@/utils/request.util';
import { AccountModule } from '@/store/modules/account';
import AgreementConsent from '../components/agreement-consent.vue';
const validatePhone = (rule: any, value: string, callback: any) => {
  const reg = /^1\d{10}$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};
const validatePassword = (rule: any, value: string, callback: any) => {
  if (value.length < 6) {
    callback(new Error('密码不能少于6位'));
  } else if (value.length > 16) {
    callback(new Error('密码不能大于16位'));
  } else {
    callback();
  }
};
const validatePasswordConfrim = (rule: any, value: string, callback: any) => {
  if (value.length < 6) {
    callback(new Error('密码不能少于6位'));
  } else if (value.length > 16) {
    callback(new Error('密码不能大于16位'));
  } else {
    callback();
  }
};

@Component({
  components: {
    AgreementConsent,
  },
})
export default class Index extends Vue {
  registerFormRef = null;
  registerForm = {
    enterpriseName: '',
    nickname: '',
    mobile: '',
    provinceCode: '',
    cityCode: '',
    // password: '',
    // passwordConfirm: '',
    code: '',
    captcha: '',
    inviteCode: '',
    validate: false,
  };
  registerFormRules = {
    enterpriseName: [
      {
        required: true,
        message: '请输入公司名称',
        trigger: 'blur',
      },
    ],
    nickname: [
      {
        required: true,
        message: '请输入你的用户名称',
        trigger: 'blur',
      },
    ],
    provinceCode: [
      {
        required: true,
        message: '请选择省市',
        trigger: 'blur',
      },
    ],
    mobile: [
      {
        required: true,
        message: '请输入你的手机号',
        trigger: 'blur',
      },
      { validator: validatePhone, trigger: 'blur' },
    ],
    // password: [
    //   {
    //     required: true,
    //     message: '请输入你的密码',
    //     trigger: 'blur',
    //   },
    //   { validator: validatePassword, trigger: 'blur' },
    // ],
    // passwordConfirm: [
    //   {
    //     required: true,
    //     message: '请确认密码',
    //     trigger: 'blur',
    //   },
    //   { validator: validatePasswordConfrim, trigger: 'blur' },
    // ],
    code: [
      {
        required: true,
        message: '请输入你获取到的验证码',
        trigger: 'blur',
      },
    ],
    captcha: [
      {
        required: true,
        message: '请输入你获取到的bp验证码',
        trigger: 'blur',
      },
    ],
  };
  loading = false;
  buttonText = '获取验证码';
  disabled = false;
  duration = 60;
  timer: any = null;
  agreementAccepted = false;
  proviceList = [];
  cityList = [];
  async mounted() {
    await this.getProvince();
  }

  async getProvince() {
    await GetProvinces().then(res => {
      this.proviceList = res;
    });
  }
  async proviceChange() {
    await GetCity({ code: this.registerForm.provinceCode }).then(res => {
      this.cityList = res;
    });
  }

  cityChange() {}
  async getPhoneCode() {
    if (this.disabled) return;
    if (!this.ensureAgreementAccepted()) return;
    clearInterval(this.timer);
    const reg = /^1\d{10}$/;
    if (!reg.test(this.registerForm.mobile)) {
      this.$message.error('请输入正确的手机号');
      return;
    }
    await GetPhoneCode({
      mobile: this.registerForm.mobile,
      validate: false,
      agreementAccepted: true,
    }).then(res => {
      this.disabled = true;
      let n = 60;
      this.timer = setInterval(() => {
        if (n > 0) {
          n--;
          this.buttonText = '重新获取(' + n + 's)';
        } else {
          clearInterval(this.timer);
          this.buttonText = '获取验证码';
          this.disabled = false;
        }
      }, 1000);
    });
  }

  // 校验验证码
  async validateCode() {
    await checkBpCaptcha({
      captcha: this.registerForm.captcha,
    })
      .then(() => {
        this.$message.success('验证通过');
      })
      .catch(() => {
        this.registerForm.captcha = '';
      });
  }

  async handleRegister() {
    if (!this.ensureAgreementAccepted()) return;
    // if (this.registerForm.password != this.registerForm.passwordConfirm) {
    //   this.$message.warning('两次输入密码不一致');
    //   return;
    // }
    (this.$refs['registerFormRef'] as any).validate().then((res: Boolean) => {
      if (res) {
        Register({ ...this.registerForm, agreementAccepted: true }).then(res => {
          if (res.token) {
            this.$message.success('登录成功');
            AccountModule.setToken({ key: 'user_token', token: res.token });
            res.token && request.setToken(res.token);
            this.$router.replace({
              path: '/index',
            });
            return;
            this.$router.replace({
              path: '/login',
            });
            PwdLogin({
              mobile: this.registerForm.mobile,
              code: this.registerForm.code,
            }).then((res: any) => {
              this.$message.success('登录成功');
              AccountModule.setToken({ key: 'user_token', token: res.token });
              res.token && request.setToken(res.token);
              this.$router.replace({
                path: '/index',
              });
            });
          }
        });
      }
    });
  }

  ensureAgreementAccepted() {
    if (this.agreementAccepted) return true;
    this.$message.warning('请先阅读并同意《星云平台用户协议》和《星云平台隐私政策》');
    return false;
  }

  toLogin() {
    this.$router.push('/login');
  }
}
